module.exports = __webpack_public_path__ + "static/media/wow_eggs.90c00209.gif";